/* eslint-disable @typescript-eslint/camelcase */
import { CaseAlerts } from '../../models/CaseAlerts';

const caseAlerts: CaseAlerts = {
  cases_to_be_closed: 17,
  work_docs_expiring: 5,
  cases_with_new_updates: 11,
  recently_auto_closed: 12,
};

export default caseAlerts;
